import React, { useEffect, useState } from 'react';
import * as S from './styles';

type CounterBlackFridayProps = {
	title: string;
	endDate: string; // ex: "2025-08-06T12:40"
	style?: React.CSSProperties | undefined;
};

type Pair = { first: number; second: number };

export default function CounterBlackFriday({
	title,
	endDate,
	style
}: CounterBlackFridayProps) {
	const [hour, setHour] = useState<Pair>({ first: 0, second: 0 });
	const [minute, setMinute] = useState<Pair>({ first: 0, second: 0 });
	const [seconds, setSeconds] = useState<Pair>({ first: 0, second: 0 });

	useEffect(() => {
		// valida formato com hora (HH:mm ou HH:mm:ss)
		const isoTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/;
		if (!isoTimeRegex.test(endDate)) {
			console.error(
				'endDate inválido (esperado YYYY-MM-DDTHH:mm ou YYYY-MM-DDTHH:mm:ss):',
				endDate
			);
			return;
		}

		const target = new Date(endDate);
		if (isNaN(target.getTime())) {
			console.error('Data inválida em endDate:', endDate);
			return;
		}

		let intervalId: ReturnType<typeof setInterval> | null = null;

		const setPair = (num: number): Pair => {
			// garante sempre 2 dígitos (para horas > 99 mostra os 2 últimos dígitos)
			const s = Math.max(0, Math.floor(num)).toString().padStart(2, '0');
			const a = s[s.length - 2];
			const b = s[s.length - 1];
			return { first: Number(a), second: Number(b) };
		};

		const tick = () => {
			const now = Date.now();
			const diffMs = target.getTime() - now;

			if (diffMs <= 0) {
				setHour({ first: 0, second: 0 });
				setMinute({ first: 0, second: 0 });
				setSeconds({ first: 0, second: 0 });
				if (intervalId) clearInterval(intervalId);
				return;
			}

			const totalSec = Math.floor(diffMs / 1000);
			const h = Math.floor(totalSec / 3600);
			const m = Math.floor((totalSec % 3600) / 60);
			const s = totalSec % 60;

			setHour(setPair(h));
			setMinute(setPair(m));
			setSeconds(setPair(s));
		};

		// inicializa o intervalo ANTES e depois faz a primeira atualização
		intervalId = setInterval(tick, 1000);
		tick();

		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [endDate]);

	return (
		<S.container style={{ ...style }}>
			<S.title>{title}</S.title>

			<S.timer>
				<S.group>
					<div>
						<S.number>
							<p>{hour.first}</p>
						</S.number>
						<S.number>
							<p>{hour.second}</p>
						</S.number>
						<b>:</b>
					</div>
					<S.hourText>horas</S.hourText>
				</S.group>

				<S.group>
					<div>
						<S.number>
							<p>{minute.first}</p>
						</S.number>
						<S.number>
							<p>{minute.second}</p>
						</S.number>
						<b>:</b>
					</div>
					<S.hourText>min</S.hourText>
				</S.group>

				<S.group>
					<div>
						<S.number>
							<p>{seconds.first}</p>
						</S.number>
						<S.number>
							<p>{seconds.second}</p>
						</S.number>
					</div>
					<S.hourText>seg</S.hourText>
				</S.group>
			</S.timer>
		</S.container>
	);
}
